import { render, staticRenderFns } from "./WorkerAccountConfigModal.vue?vue&type=template&id=95649f6e"
import script from "./WorkerAccountConfigModal.vue?vue&type=script&lang=js"
export * from "./WorkerAccountConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Fworker%2Fworker-account-config-modal%2FWorkerAccountConfigModal.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports